module.exports = __webpack_public_path__ + "static/slack-guid-2-6cac5c75d600d12feda9aac443a42053.png";